// Lightweight Script für textmarker H1 Effect mit Zeilenumbruch-Support
(function() {
  // Prüfen ob home-header Bereich existiert
  const homeHeader = document.querySelector('.home-header');
  if (!homeHeader) return;
  
  // H1 Element im home-header finden
  const h1 = homeHeader.querySelector('h1');
  if (!h1) return;
  
  // Originalen HTML-Inhalt speichern (inkl. <br/> Tags)
  const originalHTML = h1.innerHTML;
  
  // CSS-Klasse hinzufügen
  h1.classList.add('textmarker-title');
  
  // Spans für den Effekt hinzufügen - HTML-Struktur beibehalten
  h1.innerHTML = `<span><span>${originalHTML}</span></span>`;
})();